<template>
  <div id="app">
    <Outdated ref="outdated"></Outdated>
    <div class="header">

      <div class="site-header">
        <a :href="$utils.getWpPath('')" class="custom-logo">
          <img class="logo-domain" src="./assets/domain-custom/base/eef-logo.png" :srcset="`${images.logo1} 1x, ${images.logo2} 2x`" :alt="$config.WEBSITE_NAME + 'Shop Logo'" />
        </a>
        <!-- <span class="bg-overlap bg-overlap__col1"></span>
        <span class="bg-overlap bg-overlap__col2"></span>
        <span class="bg-overlap bg-overlap__col3"></span> -->
      </div>

        <!-- <div class="site-header" v-if="!isNavFocusMode">
          <a :href="$utils.getWpPath('')" class="custom-logo">
            <img class="logo-domain-sm show-sm" src="./assets/domain-custom/base/logo-domain-desktop.png" :srcset="`${images.logo1} 1x, ${images.logo2} 2x`" :alt="$config.WEBSITE_NAME + 'Shop Logo'" />
            <img class="logo-domain hide-sm" src="./assets/domain-custom/base/logo-domain-desktop.png" :srcset="`${images.logo3} 1x, ${images.logo4} 2x`" :alt="$config.WEBSITE_NAME + 'Shop Logo'" />
          </a> -->
          <!-- Login section -->
          <!-- <div class="dropdown dropdown--profile hide-sm" v-if="!isLoggedIn">
            <a href="#" class="dropdown__toggle" @click.prevent="showLoginModal">เข้าสู่ระบบ</a>
          </div>
          <div class="dropdown dropdown--profile hide-sm" v-if="isLoggedIn" ref="dropdown">
            <a class="dropdown__toggle" href="#"  @click.prevent="toggleDropdown()">
              {{ name }}
              <img class="dropdown__icon"
                src="./assets/img/ic-toggle.png"
                :srcset="`${require('./assets/img/ic-toggle.png')} 1x, ${require('./assets/img/ic-toggle@2x.png')} 2x`" alt="Account" />
            </a>
            <div class="dropdown__menu" v-show="dropdownVisible">
              <ul class="list list--dropdown">
                <li class="list__item">
                  <router-link to="/user/pages" class="list__link">กองผ้าป่าของฉัน</router-link></li>
                <li class="list__item">
                  <router-link to="/user/profile" class="list__link">แก้ไขข้อมูลส่วนตัว</router-link></li>
                <li class="list__item">
                  <router-link to="/user/logout" class="list__link">ออกจากระบบ</router-link></li>
              </ul>
            </div>
          </div> -->

          <!-- <div class="top-bar">
            <a :href="$utils.getWpPath('howto-donate')" target="_blank" class="btn--flat product-page"><i class="fas fa-info-circle"></i> วิธิบริจาค</a>
            <a :href="$utils.getWpPath('howto-createpage')" target="_blank" class="btn--flat create-page"><i class="fas fa-info-circle"></i> วิธิสร้างกอง</a>
          </div> -->
        <!-- </div> -->


        <cart-status-icon v-if="showCartStatus"></cart-status-icon>

        <!-- <div class="main-navigation" v-if="!isNavFocusMode">
          <a class="hamburger" href="#" @click.prevent="showMenu()">
          <span class="hamburger__menu">
              <span class="bread"></span>
              <span class="bread"></span>
              <span class="bread"></span>
          </span>
          </a>

          <nav-menu-top class="hide-sm"></nav-menu-top>

          <transition>
            <nav-menu v-show="menuVisible" v-on:hideMenu="hideMenu()"></nav-menu>
          </transition>
        </div> -->
        <!-- /main-menu -->

        <!-- <div class="header-right hide-sm">
          <ul class="nav-language">
            <li class="lang-item lang-item-th"><a :href="$utils.getWpPath('/')" class="nav__link">ไทย</a></li>
            <li class="lang-item lang-item-en"><a :href="$utils.getWpPath('/en')" class="nav__link">English</a></li>
          </ul>
        </div> -->
      <!-- <span class="bg-overlap bg-overlap__col1"></span>
      <span class="bg-overlap bg-overlap__col2"></span>
      <span class="bg-overlap bg-overlap__col3"></span>	 -->
    </div>
    <!-- <div class="sub-header">
      <div class="header__left" v-if="backVisible && isNavFocusMode">
        <a href="#" @click.prevent="back()"><img :src="$utils.svg(require('./assets/img/left-arrow.svg'))" width="30" alt="Back" /></a>
      </div>
      <h1 class="page-title text-center" v-if="navTitle">{{ navTitle }}</h1>
    </div> -->

    <transition name="fade">
      <router-view :key="$route.fullPath" class="app-frame-inner"></router-view>
    </transition>

    <site-footer></site-footer>

    <!-- <div class="footer hide-sm">
      <div class="container">
        <div class="fl-left">Copyright {{ $config.WEBSITE_NAME }} 2018, All rights reserved</div>
        <div class="fl-right">
          <a :href="$utils.getWpPath('terms')">Terms of service</a> |
          <a :href="$utils.getWpPath('policy')">Privacy Policy</a>
        </div>

      </div>

    </div> -->

    <login-modal ref="loginModal" />
    <vue-toast ref="toast"></vue-toast>
    <vue-modal ref="modal"></vue-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import CartStatusIcon from './components/CartStatusIcon.vue'
import VueToast from 'vue-toast'
import VueModal from './components/Modal'
import 'vue-toast/dist/vue-toast.min.css'
import NavMenu from './components/NavMenu.vue'
import NavMenuTop from './components/NavMenuTop.vue'
import Outdated from './components/Outdated.vue'
import SiteFooter from './components/SiteFooter.vue'
import LoginModal from './components/LoginModal'

export default {
  components: {
    NavMenu,
    NavMenuTop,
    CartStatusIcon,
    VueToast,
    VueModal,
    Outdated,
    SiteFooter,
    LoginModal
  },
  name: 'app',
  mounted () {
    this.$store.dispatch('initCart')
    this.$store.dispatch('initCheckoutInfo')
    this.$store.dispatch('initWebSocket')
    this.$store.dispatch('loadProducts')
    this.$store.dispatch('setToast', this.$refs.toast)

    Vue.prototype.$modal = this.$refs.modal
    Vue.prototype.$loginModal = this.$refs.loginModal
    Vue.prototype.$outdated = this.$refs.outdated

    let totalWait = 0
    const t = setInterval(() => {
      if (totalWait > 5000) {
        clearTimeout(t)
      }
      if (window.fbq) {
        clearTimeout(t)
        window.fbApiInit = true
      }
      totalWait += 500
    }, 500)
  },
  data () {
    return {
      menuVisible: false,
      dropdownVisible: false
    }
  },
  created () {
    window.$wid = Math.random()
    // window.addEventListener('storage', this.syncCart, false)
  },
  unmounted () {
    // window.removeEventListener('storage', this.syncCart, false)
  },
  computed: {
    showCartStatus () {
      return false
      // return this.$store.state.showCartStatusComponent
    },
    images () {
      return {
        logo1: require('./assets/domain-custom/base/eef-logo.png'),
        logo2: require('./assets/domain-custom/base/eef-logo@2x.png'),
        logo3: require('./assets/domain-custom/base/eef-logo.png'),
        logo4: require('./assets/domain-custom/base/eef-logo@2x.png')
      }
    },
    isLoggedIn () {
      return this.$store.state.token
    },
    isNavFocusMode () {
      return this.$store.state.isNavFocusMode
    },
    navTitle () {
      return this.$store.state.navTitle
    },
    backVisible () {
      return this.$store.state.backVisible
    },
    name () {
      const user = this.$store.state.user
      if (user.firstName || user.lastName) {
        return `${this.$store.state.user.firstName} ${this.$store.state.user.lastName}`
      } else if (user.email && !user.email.match(/tel.(\d+)@tcfe.or.th/g)) {
        return user.email
      } else if (user.telNo) {
        return user.telNo
      } else {
        return '<Unknown>'
      }
    }
  },
  methods: {
    showLoginModal () {
      if (this.$route.name !== 'user_login') {
        this.$loginModal.show()
      }
    },
    syncCart (ev) {
      this.$store.dispatch('initCart')
    },
    showMenu () {
      this.menuVisible = true
    },
    hideMenu () {
      this.menuVisible = false
    },
    back () {
      if (this.$store.state.routeBeforeCheckout) {
        this.$router.push(this.$store.state.routeBeforeCheckout)
      } else {
        this.$router.push('/')
      }
    },
    clickListener (ev) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(ev.target)) {
        this.dropdownVisible = false
      }
    },
    toggleDropdown () {
      this.dropdownVisible = !this.dropdownVisible
    },
    hideDropdown () {
      this.dropdownVisible = false
    }
  },
  watch: {
    '$route': function (to, from) {
      this.hideMenu()
      this.hideDropdown()
    }
  }
}
</script>

<style lang="scss">

.sub-header {
  background: #CCE9EE;
  padding: 2rem 0 0;
  .header__title { color: #153050; }
}

#app {
  // background-color: #CCE9EE;
}

.vue-toast-manager_container {
  top: 120px;
  z-index: 5;
  font-size: 14px;

  &.__bottom {
    bottom: auto !important;
  }

  .vue-toast_container {
    background: black;
    left: 50% !important;
    transform: translateX(-50%) !important;
    text-align: center;
    padding: 0;
    border-radius: 6px;
    opacity: .8;

    .vue-toast_message {
      padding: 4px 8px;
      margin: 2px;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}
.fade-enter-active {
  transition-delay: .25s;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

.slide-down-enter-active, .slide-down-leave-active {
  &.slide-down-wrapper {
    overflow: hidden;
    transition-property: all;
    transition-duration: .45s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }

  .slide-down-item {
    pointer-events: none;
    z-index: -1;
    transition-property: all;
    transition-duration: .45s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }
}
.slide-down-enter-active {
  &.slide-down-wrapper {
    max-height: 100vh;
    transform: none;
    opacity: 1;
  }

  .slide-down-item {
    transform: translateY(0);
    opacity: 1;
  }
}
.slide-down-enter, .slide-down-leave-active {
  &.slide-down-wrapper {
    max-height: 0;
    transform: none;
    opacity: 1;
  }

  .slide-down-item {
    transform: translateY(-10vh);
    opacity: 0;
  }
}
.slide-down-leave {
  &.slide-down-wrapper {
    max-height: 100vh;
    transform: none;
    opacity: 1;
  }

  .slide-down-item {
    transform: translateY(0);
    opacity: 1;
  }
}

.pull-right-enter-active  {
  transition-property: transform, opacity;
  transition-duration: .25s;
  transform: translateX(0);
  opacity: 1;
}
.pull-right-leave-active {
  transition-property: transform, opacity;
  transition-duration: .75s;
  transform: translateX(0);
  opacity: 1;
}
.pull-right-enter, .pull-right-leave-active {
  transform: translateX(-100%);
  opacity: .6;
}

.page-title {
  color: #153050;
  font-family: 'Wittaya-Medium';
  font-size: 2rem;
  margin-bottom: 1.5rem;
  &--campaign {
    font-family: 'Wittaya-Light';
    font-weight: 300;
    font-size: 1.25rem;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?515ca3fb